export default __webpack_public_path__ + "static/media/Unstoppable_Domains-Sign-Dark_3x.57fa5926.png";